export const SITE_TYPES_REQUEST = 'sites/SITE_TYPES_REQUEST';
export const SITE_TYPES_SUCCESS = 'sites/SITE_TYPES_SUCCESS';
export const SITE_TYPES_FAILURE = 'sites/SITE_TYPES_FAILURE';

export const GET_SITE_RESOURCES_REQUEST = 'sites/GET_SITE_RESOURCES_REQUEST';
export const GET_SITE_RESOURCES_SUCCESS = 'sites/GET_SITE_RESOURCES_SUCCESS';
export const GET_SITE_RESOURCES_FAILURE = 'sites/GET_SITE_RESOURCES_FAILURE';

export const SITE_TYPES_DICT_REQUEST = 'sites/SITE_TYPES_DICT_REQUEST';
export const SITE_TYPES_DICT_SUCCESS = 'sites/SITE_TYPES_DICT_SUCCESS';
export const SITE_TYPES_DICT_FAILURE = 'sites/SITE_TYPES_DICT_FAILURE';
